import { render, staticRenderFns } from "./product8.vue?vue&type=template&id=159bd226&scoped=true"
import script from "./product8.vue?vue&type=script&lang=js"
export * from "./product8.vue?vue&type=script&lang=js"
import style0 from "./product8.vue?vue&type=style&index=0&id=159bd226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159bd226",
  null
  
)

export default component.exports